import { produce } from 'immer';

export const INITIAL_STATE = {
  profile: null,
  filtro: {
    status: 'emprocesso',
    retranca: null,
    setor: '',
    setorsolicitante: null,
    pendenteeng: false,
    tipo: [],
    emissoras: [],
    editor: null,
  },
  emissora: { value: 0, label: '' },
  isDarkTheme: true,
  isSideBarMini: false,
  currentDate: null,
};

export default function usuario(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@auth/SIGN_IN_SUCCESS': {
        draft.profile = action.payload.usuario;
        draft.filtro = INITIAL_STATE.filtro;
        draft.emissora = {
          value: action.payload.usuario.emissoras[0].id,
          label: action.payload.usuario.emissoras[0].nome,
        };
        draft.currentDate = new Date();
        break;
      }
      case '@user/UPDATE_PROFILE_SUCCESS': {
        draft.profile = action.payload.profile;
        break;
      }
      case '@user/UPDATE_SELECTED_EMISSORA': {
        draft.emissora = action.payload.emissora;
        break;
      }
      case '@user/UPDATE_FILTRO': {
        draft.filtro = action.payload.filtro;

        break;
      }
      case '@user/SWITCH_THEME': {
        draft.isDarkTheme = !draft.isDarkTheme;
        break;
      }
      case '@user/EXPAND_BAR': {
        draft.isSideBarMini = !draft.isSideBarMini;
        break;
      }
      case '@user/CURRENT_DATE': {
        if (action.payload.currentDate) {
          draft.currentDate = action.payload.currentDate;
        }
        break;
      }
      case '@user/UPDATE_PROFILE_NOME': {
        if (action.payload.nome) {
          draft.profile.nome = action.payload.nome;
        }

        if (action.payload.avatarURL) {
          draft.profile.avatar_url = action.payload.avatarURL;
        }

        break;
      }
      case '@auth/SIGN_OUT': {
        draft.profile = null;
        draft.emissora = null;
        draft.currentDate = null;
        break;
      }

      default:
    }
  });
}
